import { SentinelApiError } from '@sentinel/api-client';

export class UnauthenticatedError extends SentinelApiError {
  constructor(detail?: unknown) { super('unauthenticated', 'session expired or missing', 401, detail); }
}
export class StepUpRequiredError extends SentinelApiError {
  constructor(detail?: unknown) { super('step_up_required', 'fresh authentication required', 403, detail); }
}
